export const CREDIT_SCORES = new Map([
  ['780+', 780],
  ['760-779', 760],
  ['740-759', 740],
  ['720-739', 720],
  ['700-719', 700],
  ['680-699', 680],
  ['660-679', 660],
  ['620-659', 620],
  ['Below 620', 619],
  ["I'm not sure", 781],
]);
